import { APIService } from "../../services/api-service";

export type PermissionDefinition = {
  id: string;
  name: string;
  description: string;
  isCritical: boolean;
};

export type PermissionGroupDefinition = {
  id: string;
  name: string;
  description: string;
  permissions: PermissionDefinition[];
};

export type AllPermissionsResponse = {
  permissions: string[];
  groups: PermissionGroupDefinition[];
};

export type CurrentUserPermissionsResponse = {
  effectivePermissions: string[];
};

export type NavigationItem = {
  id: string;
  path: string;
  name: string;
};

export type NavigationResponse = {
  items: NavigationItem[];
};

export class PermissionService extends APIService {
  static PERMISSIONS_URL = `${this.API_PREFIX_URL}/permissions`;

  static getAllPermissions = () =>
    this.get<AllPermissionsResponse>(
      PermissionService.PERMISSIONS_URL + "/all",
      { withAuthToken: true },
    );

  static getCurrentUserPermissions = () =>
    this.get<CurrentUserPermissionsResponse>(
      PermissionService.PERMISSIONS_URL + "/self",
      { withAuthToken: true },
    );

  static getNavigation = () =>
    this.get<NavigationResponse>(
      PermissionService.PERMISSIONS_URL + "/navigation",
      { withAuthToken: true },
    );
}
